export default {
  title: 'Rental SETTINGS',
  items: {
    RentalEnabled: {
      label: 'Enable Rental',
      type: 'boolean'
    },
    RentalMaxDuration: {
      label: 'Rental Max Duration',
      type: 'integer',
      unit: 'minutes'
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/rental.js